import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPagination from '../../components/molecules/ExPagination';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    rowsPerPage,
    page,
    handleChangePage,
    selectedPage,
    handleChangeRowsPerPage,
    updateAmountHistoryList,
    updateAmountHistoryCount,
    updateAmountHistoryOffset
  }) => {
    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>チケットID</TableCell>
                <TableCell>教室ID</TableCell>
                <TableCell>教室名</TableCell>
                <TableCell>コース名</TableCell>
                <TableCell>コースID</TableCell>
                <TableCell>利用者名</TableCell>
                <TableCell>使用日時</TableCell>
                <TableCell>修正前金額</TableCell>
                <TableCell>修正後金額</TableCell>
                <TableCell>修正日時 </TableCell>
                <TableCell>操作者</TableCell>
                <TableCell>教室振込額</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {updateAmountHistoryList &&
                updateAmountHistoryList.map(item => (
                  <TableRow key={item.ticketId}>
                    <TableCell>{item.ticketId}</TableCell>
                    <TableCell>{item.shopId}</TableCell>
                    <TableCell>{item.shopName}</TableCell>
                    <TableCell>{item.menuName}</TableCell>
                    <TableCell>{item.menuId}</TableCell>
                    <TableCell>{item.displayName}</TableCell>
                    <TableCell>{item.useDate}</TableCell>
                    <TableCell>
                      {item.historyDetailDtoList &&
                        item.historyDetailDtoList.length > 0 &&
                        item.historyDetailDtoList.map((amount, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={`${item.ticketId}_${index}`}>
                            {amount.oldAmount !== null
                              ? amount.oldAmount.toLocaleString()
                              : ''}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {item.historyDetailDtoList &&
                        item.historyDetailDtoList.length > 0 &&
                        item.historyDetailDtoList.map((amount, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={`${item.ticketId}_${index}`}>
                            {amount.newAmount !== null
                              ? amount.newAmount.toLocaleString()
                              : ''}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {item.historyDetailDtoList &&
                        item.historyDetailDtoList.length > 0 &&
                        item.historyDetailDtoList.map((amount, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={`${item.ticketId}_${index}`}>
                            {amount.editedAt}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {item.historyDetailDtoList &&
                        item.historyDetailDtoList.length > 0 &&
                        item.historyDetailDtoList.map((amount, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <div key={`${item.ticketId}_${index}`}>
                            {amount.editedBy === 'SECRETARIAT'
                              ? '事務局'
                              : '参画事業者'}
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {item.lastAmount !== null
                        ? item.lastAmount.toLocaleString()
                        : ''}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={updateAmountHistoryList}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={updateAmountHistoryCount}
            offset={updateAmountHistoryOffset}
            selectedPage={selectedPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
